export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/pages/dashboard'),
    meta: { auth: true },
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/views/pages/notification'),
    meta: { auth: true },
  },
  {
    path: '/rating',
    name: 'rating',
    component: () => import('@/views/pages/rating'),
    meta: { auth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/account/login'),
    meta: {
      guest: true
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/pages/account/register'),
    meta: {
      guest: true
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/account/forgot-password'),
    meta: {
      guest: true
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/pages/account/reset-password'),
    meta: {
      guest: true
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/pages/account/profile'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/profile-update',
    name: 'UpdateProfile',
    component: () => import('@/views/pages/account/update-profile'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/pages/chat/chat-room'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/driver',
    name: 'Driver',
    component: () => import('@/views/pages/driver/driver-list'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/driver/create',
    name: 'DriverForm',
    component: () => import('@/views/pages/driver/driver-form'),
    meta: {
      auth: true,
      verified: true
    },
  },
  {
    path: '/driver/:id',
    name: 'DriverDetail',
    component: () => import('@/views/pages/driver/driver-detail'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/driver/:id/edit',
    name: 'DriverEdit',
    component: () => import('@/views/pages/driver/driver-form-edit'),
    meta: {
      auth: true,
      verified: true
    },
  },
  {
    path: '/truck',
    name: 'Truck',
    component: () => import('@/views/pages/truck/truck-list'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/truck/create',
    name: 'TruckForm',
    component: () => import('@/views/pages/truck/truck-form'),
    meta: {
      auth: true,
      verified: true
    },
  },
  {
    path: '/truck/:id',
    name: 'TruckDetail',
    component: () => import('@/views/pages/truck/truck-detail'),
    meta: {
      auth: true,
      verified: true
    },
  },
  {
    path: '/truck/:id/edit',
    name: 'TruckEdit',
    component: () => import('@/views/pages/truck/truck-form-edit'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/job',
    name: 'Job',
    component: () => import('@/views/pages/job/job-list'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/job/create',
    name: 'JobCreate',
    component: () => import('@/views/pages/job/job-form'),
    meta: {
      auth: true,
      verified: true
    },
  },
  {
    path: '/job/:id',
    name: 'JobDetail',
    component: () => import('@/views/pages/job/job-detail'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/job/:id/edit',
    name: 'JobEdit',
    component: () => import('@/views/pages/job/job-form'),
    meta: {
      auth: true,
      verified: true
    },
  },
  {
    path: '/404',
    name: 'Page-404',
    component: () => import('@/views/pages/error/404'),
    meta: {
      auth: false,
    }
  },
  {
    path: '/403',
    name: 'Page-403',
    component: () => import('@/views/pages/error/403'),
    meta: {
      auth: false,
    }
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/pages/404'
  },
]